/**
 * Mapping of routes to components and teams for the sourcing app
 */
const teamComponentMapSourcing = [
  {
    pattern: "/",
    team: "sourcing",
    component: "root"
  },
  {
    pattern: "/login",
    team: "sourcing",
    component: "login"
  },
  {
    pattern: "/dashboard",
    team: "sourcing",
    component: "dashboard"
  },
  {
    pattern: "/reports/*/caseStatusWaterfall",
    team: "sourcing",
    component: "reports-case-waterfall"
  },
  {
    pattern: "/reports/*/*",
    team: "sourcing",
    component: "reports"
  }
]

export default teamComponentMapSourcing
